function digitsOnly(phone: string): string {
  return phone.replace(/\D/g, '');
}

export function openClienteWhatsApp(phoneNumber?: string, message: string = ''): void {
  const raw = phoneNumber ? digitsOnly(phoneNumber) : '';
  const phoneWithCountry = raw ? (raw.startsWith('55') ? raw : `55${raw}`) : '';
  const textParam = encodeURIComponent(message);
  const httpsUrl = phoneWithCountry
    ? `https://wa.me/${phoneWithCountry}?text=${textParam}`
    : `https://wa.me/?text=${textParam}`;
  window.open(httpsUrl, '_blank', 'noopener,noreferrer');
}

/** Números padrão (guincho/SOS/revisão); boleto usa getFinanceiroWhatsAppE164. */
export const CLIENTE_WHATSAPP_NUMBERS = {
  GUINCHO: '5511999999999',
  SOS: '5511999999999',
  BOLETO: '5511911975992',
  REVISAO: '5511999999999',
};
